<div class="card border border-disabled">
  <div class="card-content d-flex flex-lg-row flex-column">
    <h5 class="voucher-title mt-0 mb-0 fw-bold text-primary">
      {{ 'voucher.title' | translate }}
    </h5>

    <span class="input-group">
      <input
        type="text"
        [(ngModel)]="voucherCode"
        placeholder="INSERT CODE HERE"
        class="form-control text-center px-5 px-lg-0"
        (keyup.enter)="redeemVoucher()"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary icon text-white fw-bold py-0"
          type="button"
          (click)="redeemVoucher()"
          [disabled]="disableButton"
        >
          <i class="material-icons-outlined">arrow_forward_ios</i>
        </button>
      </div>

      <div class="text-center error-container">
        <fgbcl-errors></fgbcl-errors>
        <div class="result text-center" *ngIf="redemptionResult">
          <div class="font-size-10 mt-1" [ngClass]="redemptionResult === successMessage ? 'text-success' : ''">
            {{ redemptionResult }}
          </div>
        </div>
      </div>
    </span>
  </div>
</div>
